/**
 * @fileoverview Controller for app dialogs
 * @author David Wen (dwen@yext.com)
 */

goog.module('yext.apps.common.DialogView');
goog.module.declareLegacyNamespace();

/**
 * @constructor
 */
const DialogView = function($dialog) {
  this.$dialog = $dialog;
  this.$body = $('body');
};

DialogView.prototype.init = function() {
  this.bindClickOutsideDialog();
  this.bindClickClose();
};

DialogView.prototype.bindClickOutsideDialog = function() {
  var dialogView = this;
  this.$dialog.on('click', function(e) {
    if (e.target === dialogView.$dialog[0]) {
      dialogView.hide();
    }
  });
};

DialogView.prototype.bindClickClose = function() {
  var dialogView = this;
  this.$dialog.find('.js-close').on('click', function() {
    dialogView.hide();
  });
};

DialogView.prototype.hide = function() {
  this.$dialog.hide();
};

DialogView.prototype.show = function() {
  this.$dialog.css('display', 'flex');
};

exports = DialogView;
